export enum WarehouseProductListItemAction {
  Edit,
  Preview,
  DownloadLabel,
}
